
import { Vue, Component, Prop } from "vue-property-decorator";

interface PersonalConsiderationsData {
  pets: string[];
  accessibility_issues: string;
  safety_concerns: string;
  hobbies: string[];
  interests: string;
  cultural_considerations: string;
  religious_practices: string;
  dietary_restrictions: string;
}

@Component
export default class PersonalConsiderations extends Vue {
  @Prop({ required: true }) readonly data!: PersonalConsiderationsData;
}
